import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute  } from '@angular/router';
import { UserService, ShowHideInput, PatientService } from '../../shared';
import { environment } from '../../shared/config/app-config';


@Component({
  templateUrl: 'supportpage.component.html',
  styleUrls: ['../style.component.css']
  
  
})

export class SupportpageComponent implements OnInit {
  public data: Object;
  params:any;
  path:any={};
  public myobj:any = {};
  public myobj1:any = {};
  public apiurl:any = environment.api_url;
  constructor(
    
    private activeroute : ActivatedRoute,
    private routers : Router,
    private patientservice:PatientService,
   
    
  ) {
    
  }


  
  
  ngOnInit() {
    this.activeroute.params.subscribe( params => {
      this.params =params
      
      //////console.log(this.params)
  });

  /* this.patientservice
  .getname(this.params.patid)
  .subscribe(
    data => {

      this.path = data;
    }
  ); */
  if(window.localStorage['pwd']){
  this.myobj = JSON.parse( window.localStorage['pwd']);

  this.myobj1 = JSON.stringify(this.myobj);
  // ////console.log(this.myobj1)
  // ////console.log(this.myobj.userFnLn)
  }
  else{
    // ////console.log("logout")
    this.routers.navigate([`/login`])
  }         
   
  }
  
   upload(){
    this.routers.navigate([`/upload`])
   }
}
  

   
 
  

